import { LastMaxSize } from "../utils/resizeCard";

export class ContainerAlwaysVisibleResizeHandler {
  private resizeObserver: ResizeObserver;

  constructor(
    private maxSize: LastMaxSize,
    private customOnResize?: () => void
  ) {}

  observeContainer(resizeContainer: HTMLElement) {
    this.resizeObserver = new ResizeObserver(() => {
      this.onResize(resizeContainer);
      if (this.customOnResize) {
        this.customOnResize();
      }
    });
    this.resizeObserver.observe(resizeContainer);
  }

  disconnect() {
    this.resizeObserver.disconnect();
  }

  protected onResize(resizeContainer: HTMLElement) {
    const el = resizeContainer;
    const rect = el.getBoundingClientRect();
    const body = document.body;

    if (this.hasYOverflow(rect, el)) {
      const overflowY = body.scrollHeight - body.clientHeight;
      this.maxSize.height = el.offsetHeight - overflowY + "px";
    } else {
      this.maxSize.height = el.clientHeight + "px";
    }
    if (this.hasXOverflow(rect, el)) {
      const overflowX = body.scrollWidth - body.clientWidth;
      this.maxSize.width = el.offsetWidth - overflowX + "px";
    } else {
      this.maxSize.width = el.clientWidth + "px";
    }
  }

  protected hasYOverflow(box: DOMRect, el: HTMLElement): boolean {
    return box.top + el.offsetHeight > document.body.clientHeight;
  }

  protected hasXOverflow(box: DOMRect, el: HTMLElement): boolean {
    return box.left + el.offsetWidth > document.body.clientWidth;
  }
}
